import { defineMessages } from '@atlassian/jira-intl';

// Don't confuse Intl messages with `Flag`s
const messages: {
	boardNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	boardNotFoundDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectNotFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectNotFoundDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectNotFoundDescriptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectNotFoundGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	boardNotFound: {
		id: 'query-string-notifier.common.board-not-found',
		defaultMessage: 'Board not found',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	boardNotFoundDescription: {
		id: 'query-string-notifier.common.board-not-found-description',
		defaultMessage:
			"You tried to access a board that doesn't exist or that you don't have permission to see.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	projectNotFound: {
		id: 'query-string-notifier.common.project-not-found',
		defaultMessage: 'Project not found',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	projectNotFoundDescription: {
		id: 'query-string-notifier.common.project-not-found-description',
		defaultMessage:
			"You tried to access a project that doesn't exist or that you don't have permission to see.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	projectNotFoundDescriptionGalaxia: {
		id: 'query-string-notifier.common.project-not-found-description-galaxia',
		defaultMessage:
			"You tried to access a space that doesn't exist or that you don't have permission to see.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	projectNotFoundGalaxia: {
		id: 'query-string-notifier.common.project-not-found-galaxia',
		defaultMessage: 'Space not found.',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
